'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  width: clamp(400px, 850px, 90%);
`;

export const title = css`
  font-size: 24px;
  font-weight: 700;
  color: ${theme.colors.peoople['azul-claro-medio']};
`;

export const description = css`
  color: ${theme.colors.peoople['gris-medio-claro']};
`;

export const mobileDownload = css`
  @media screen and (width > ${theme.sizes.screens.md}) {
    display: none !important;
  }
`;

export const grid = css`
  display: grid;
  grid-template-areas:
    'image'
    'content';
  justify-content: center;
  gap: 1rem;
  grid-template-rows: 140px 1fr;

  @media screen and (width > ${theme.sizes.screens.md}) {
    grid-template-areas: 'image content';
    grid-template-rows: initial;
    grid-template-columns: 290px 1fr;
  }
`;

export const image = css`
  grid-area: image;
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
`;

export const content = css`
  grid-area: content;
  display: flex;
  gap: 1rem;
  flex-direction: column;
`;

export const desktopDownload = css`
  gap: 1rem;
  display: none;
  @media screen and (width > ${theme.sizes.screens.md}) {
    color: ${theme.colors.peoople['gris-medio-claro']};
    display: grid;
    grid-template-areas:
      'title title'
      'qr stores';
  }
`;

export const downloadTitle = css`
  font-size: 18px;
  grid-area: title;
  font-weight: 700;
`;

export const qr = css`
  --qr-size: 150px;
  grid-area: qr;
  position: relative;
  width: var(--qr-size);
  height: var(--qr-size);
  @media screen and (width > ${theme.sizes.screens.lg}) {
    --qr-size: 200px;
  }
`;

export const downloadHereText = css`
  font-size: 14px;
  @media screen and (width > ${theme.sizes.screens.md}) {
    font-size: 16px;
  }
`;

export const storeBadges = css`
  display: flex;
  grid-area: stores;
  flex-direction: column;
  align-items: stretch;
  gap: 0.5rem;
  justify-content: center;
`;
